import { render, staticRenderFns } from "./AccordionView.vue?vue&type=template&id=193769e1"
import script from "./AccordionView.vue?vue&type=script&lang=js"
export * from "./AccordionView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports